import React, { useState } from "react";
import { css } from "emotion";
import { colors } from "../styles/theme";

const Toggle = ({ value, toggle }) => {
  return (
    <div>
      <div className={container}>
        <input
          type="checkbox"
          id="checkbox"
          checked={value}
          onChange={toggle}
        />
        <div className="slider round"></div>
      </div>
    </div>
  );
};

export default Toggle;

const container = css`
  margin-top: 4px;
  display: inline-block;
  height: 19px;
  position: relative;
  width: 32px;
  cursor: pointer;

  #checkbox {
    opacity: 0;
    position: relative;
    z-index: 100;
    height: 20px;
    width: 50px;
    background-color: red;
    cursor: pointer;
  }

  .slider {
    background-color: ${colors.placeholderText};
    bottom: 0;
    pointer-events: none;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.3s;
  }

  .slider:before {
    background-color: white;
    bottom: 2px;
    content: "";
    left: 2px;
    position: absolute;
    transition: 0.4s;
    height: 16px;
    width: 16px;
  }

  #checkbox:checked + .slider {
    background-color: ${colors.accentColor};
  }

  #checkbox:checked + .slider:before {
    transform: translateX(12px);
  }

  .slider.round {
    border-radius: 40px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`;
